import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportModalDialogComponent } from '../report-modal-dialog/report-modal-dialog.component';

@Component({
    selector: 'app-combined-report',
    templateUrl: './combined-report.component.html',
    styleUrls: ['./combined-report.component.scss']
})
export class CombinedReportComponent {

    constructor(private dialog: MatDialog,) { }
    OpenDialog(type: any) {
        debugger
        const dialogRef = this.dialog.open(ReportModalDialogComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: '550px',
            data: {
                displayPanel: type,
                reportType: type == 'SendOverEmail' ? 5 : null
            }
        });

        dialogRef.afterClosed().subscribe(preferedType => {
            if (preferedType) {
                const dialogRefTable = this.dialog.open(ReportModalDialogComponent, {
                    autoFocus: false,
                    disableClose: true,
                    panelClass: 'mat-dialog',
                    width: '1200px',
                    data: {
                        displayPanel: 'uploadExcelFileTable',
                        reportType: type == 'SendOverEmail' ? 5 : null,
                        tableData: preferedType
                    }
                });
                dialogRefTable.afterClosed().subscribe(res => {
                    if (res && res === 'CloseAll') {
                    }else{
                        this.OpenDialog('uploadExcelFile');
                    }
                });

            }
        });
    }
}
